Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=





mapHealthState;var _MQTTActions=require('../actions/MQTTActions');function mapHealthState(state){
var serialNumber=state._mqttRawTopic.split('/')[1].split(':')[1];

if(!serialNumber){
return null;
}

if(state.getPositionHealth()){
return(0,_MQTTActions.updateSecurityDeviceHealthState)(_extends({},

state.toObject(),{
statusUpdatedAt:state.getStatusUpdatedAt().toDate()}),

serialNumber);

}else if(state.getFixtureHealth()){

}else if(state.getStoreHealth()){

}

return null;
}